import { render, staticRenderFns } from "./LichSuPhieuTuVan.vue?vue&type=template&id=5d2468f9&scoped=true"
import script from "./LichSuPhieuTuVan.vue?vue&type=script&lang=js"
export * from "./LichSuPhieuTuVan.vue?vue&type=script&lang=js"
import style0 from "./LichSuPhieuTuVan.vue?vue&type=style&index=0&id=5d2468f9&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2468f9",
  null
  
)

export default component.exports